(() => {
  // Only run if badges exist
  if (!document.querySelector('[data-ndd-badge]')) return;

  // Helper: Formatting date keys for exclusion check
  const getDateString = (d) => {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  };

  // Helper: Check if date is excluded
  const isDateExcluded = (d) => {
    // Access the global variable set by the main widget script
    const exclusions = Array.isArray(window.excluded_dates) ? window.excluded_dates : [];
    return exclusions.includes(getDateString(d));
  };

  // Helper: Check Express Time (Fri-Sun or Mon-Thu > 11:30)
  const getIsExpress = (now) => {
    const day = now.getDay(); // 0=Sun, 5=Fri, 6=Sat
    
    // 1. Weekend Window (Fri, Sat, Sun)
    if (day === 5 || day === 6 || day === 0) return true;
    
    // 2. Weekday Window (Mon-Thu after 11:30)
    const cutoff = new Date(now);
    cutoff.setHours(11, 30, 0, 0);
    return now >= cutoff;
  };

  // Helper: Get Current Variant ID from Form or URL
  const getCurrentVariantId = () => {
    // 1. Try Form Input
    const form = document.querySelector('form[action*="/cart/add"]');
    const input = form?.querySelector('input[name="id"]');
    if (input) return input.value;

    // 2. Try URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('variant')) return urlParams.get('variant');

    // 3. Try Shopify Analytics
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      return window.ShopifyAnalytics.meta.selectedVariantId;
    }
    
    return null; 
  };

  const updateBadges = () => {
    const now = new Date();
    const isExpress = getIsExpress(now);
    
    // Check Exclusions rules
    // Rule: If NOT express (meaning we are promoting "Tomorrow"), check if "Tomorrow" is excluded.
    let isExcludedDateBlocked = false;
    
    if (!isExpress) {
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (isDateExcluded(tomorrow)) {
        isExcludedDateBlocked = true;
      }
    }

    const currentVariantId = getCurrentVariantId();

    document.querySelectorAll('[data-ndd-badge]').forEach(badge => {
      // 1. Variant Check (for Product Page context)
      // The badge has a data attribute with valid variant IDs [123, 456]
      const validVariants = badge.dataset.validVariants 
        ? JSON.parse(badge.dataset.validVariants) 
        : null;

      let variantEligible = true;
      
      // Only run variant check if we are on a PDP (found an ID) and the badge has validation data
      if (currentVariantId && validVariants) {
        // We compare strings to be safe
        variantEligible = validVariants.includes(Number(currentVariantId)) || 
                          validVariants.includes(String(currentVariantId));
      }

      // 2. Determine Visibility
      // Visible if: Variant is Eligible AND (Date is NOT blocked/excluded)
      if (variantEligible && !isExcludedDateBlocked) {
        badge.style.display = ''; // Show
      } else {
        badge.style.display = 'none'; // Hide
      }

      // 3. Update Text (Express vs Next Day)
      const textEl = badge.querySelector('.ndd-badge__text');
      if (textEl) {
        const currentIsExpress = textEl.dataset.express === 'true';
        if (currentIsExpress !== isExpress) {
          textEl.dataset.express = isExpress;
          textEl.textContent = isExpress ? 'Express Delivery' : 'Next Day Delivery';
        }
      }
    });
  };
  
  // Update initially
  updateBadges();
  
  // Listen for changes
  setInterval(updateBadges, 60000); // Time updates
  
  // Listen for Variant Changes (Standard Shopify themes)
  document.addEventListener('variant:change', () => setTimeout(updateBadges, 100));
  document.addEventListener('variant:changed', () => setTimeout(updateBadges, 100));
  
  // Observe Form changes (Fallback for variant switching)
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    const input = form.querySelector('input[name="id"]');
    if (input) {
      input.addEventListener('change', updateBadges);
    }
    form.addEventListener('change', () => setTimeout(updateBadges, 100));
  }
})();